var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApprovals = function SvgApprovals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#approvals_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.344 8.59.987.987a.128.128 0 0 0 .198 0l1.974-1.975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.627 13.506A4.887 4.887 0 1 0 3.75 8.63a4.877 4.877 0 0 0 4.877 4.877v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.247 1.718V.494H.492v9.754h1.303"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "approvals_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgApprovals;